export default __webpack_public_path__ + "static/media/telephone-fill.92e390f9.svg";